const isSelected = (location, url, onlyActiveOnIndex = false) => {
  const isActive = onlyActiveOnIndex
    ? location.pathname === url
    : location.pathname.startsWith(url);

  return isActive;
};
export default isSelected;
